// Generated by https://quicktype.io

export interface AppLookup extends LookupValue {
  lookupType: string;
}

export interface ConfigurationFiltersLookups {
  tappedHoleSizes: AppLookup[],
  oringOptions: AppLookup[],
  bevelOptions: AppLookup[]
}

export interface LookupValue {
  id?: number;
  text?: string;
  numericValue?: number;
  description?: string;
  sortOrder?: number;
  inactiveDate?: Date;
  createdDate?: string;
  createdBy?: string;
  updatedDate?: string;
  updatedBy?: string;
  outsideDiameter?: number;
}

export function lookupValueFactory(obj: Partial<LookupValue>): LookupValue {
  return {
    id: obj.id,
    text: obj.text,
    description: obj.description,
    sortOrder: obj.sortOrder,
    inactiveDate: obj.inactiveDate,
    createdDate: obj.createdDate,
    createdBy: obj.createdBy,
    updatedDate: obj.updatedDate,
    updatedBy: obj.updatedBy,
  }
}

export interface PigSigLookup extends LookupValue {
  partNumberValue: string;
  default: string;
}

export interface ClosureLookups {
  diameters: LookupValue[];
  wallThicknesses: LookupValue[];
  pressureRatings: LookupValue[];
  hingeOrientations: LookupValue[];
  clampRings: LookupValue[];
  designFactors: LookupValue[];
}

export interface FittingLookups {
  regions: LookupValue[];
  designFactors: LookupValue[];
  pipeSizes: LookupValue[];
  ansiClasses: LookupValue[];
  flangeTypes: LookupValue[];
  designCodes: LookupValue[];
  maxCes: LookupValue[];
  fittingTypes: (LookupValue & { imageUrl?: string })[];
}

export function fittingLookupsFactory(obj: Partial<FittingLookups>): FittingLookups {
  return {
    regions: obj.regions || [],
    designFactors: obj.designFactors || [],
    pipeSizes: obj.pipeSizes || [],
    ansiClasses: obj.ansiClasses || [],
    flangeTypes: obj.flangeTypes || [],
    designCodes: obj.designCodes || [],
    maxCes: obj.maxCes || [],
    fittingTypes: obj.fittingTypes || [],
  }
}

export interface FittingQueryResult {
  id: number;
  partNumber: string;
  productName: string;
  description: string;
  hasDrawing: boolean;
  isPreferred: boolean;
  isBuyAmerica: boolean;
}
